<template>
  <div class="nav-bottom">
    <div class="bottom">
      <ul>
        <li v-for="(item, index) in list1" :key="index">
          <div class="list-bg" @click="active(index)">
            <img :src="item.bg" />
          </div>
          <span :class="num1 == index ? 'active' : ''">{{ item.title }}</span>
          <div class="bottom-line" v-show="num1 == index"></div>
        </li>
      </ul>
      <button class="back" @click="back()">
        <img src="./../assets/img/返回.png" width="100%" height="100%" />
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "homeBottom",
  data() {
    return {
      list1: [
        {
          bg: require("./../assets/img/bottom-list2.png"),
          title: "地图引导",
          status: 0,
        },
        {
          bg: require("./../assets/img/bottom-list5.png"),
          title: "消防设备",
        },
        {
          bg: require("./../assets/img/bottom-list7.png"),
          title: "摄像头",
        },
        {
          bg: require("./../assets/img/bottom-list3.png"),
          title: "供气站",
        },
        {
          bg: require("./../assets/img/bottom-list1.png"),
          title: "志愿者服务站",
        },
        {
          bg: require("./../assets/img/bottom-list4.png"),
          title: "医疗站",
        },

        {
          bg: require("./../assets/img/bottom-list6.png"),
          title: "供电系统",
        },
      ],
      num1: -1,
      time: 500,
      show0: true,
      show1: true,
      show2: true,
      show3: true,
      show4: true,
      show5: true,
      show6: true,
      type: "",
      status: 0,
      state: "",
      isclick: true, //是否都能点击
      showNum: -1,
    };
  },
  mounted() {
    window.showfalse = this.showfalse;
    window.addEventListener("message", (e) => {
      if (e.data.type != "webpackClose") {
        this.type = e.data.type;
      }
      if (this.type == "initialize1") {
        this.initialization();
      }
    });
    this.show();
  },
  methods: {
    active(num) {
      this.EmitEvent.$emit("messaeg", -1);
      this.$store.state.activeNum = -1;
      let list2 = [
        {
          bg: require("./../assets/img/bottom-list2.png"),
          title: "地图引导",
        },
        {
          bg: require("./../assets/img/bottom-list5.png"),
          title: "消防设备",
        },
        {
          bg: require("./../assets/img/bottom-list7.png"),
          title: "摄像头",
        },
        {
          bg: require("./../assets/img/bottom-list3.png"),
          title: "供气站",
        },
        {
          bg: require("./../assets/img/bottom-list1.png"),
          title: "志愿者服务站",
        },
        {
          bg: require("./../assets/img/bottom-list4.png"),
          title: "医疗站",
        },

        {
          bg: require("./../assets/img/bottom-list6.png"),
          title: "供电系统",
        },
      ];
      this.list1 = list2;
      this.num1 = num;
      this.showReset(num);
      this.activeN(num)[num]();
    },
    goback() {
      if (this.type == "initialize") {
        document.getElementById("iframe").contentWindow.MMAPI.equipment("nish");
        document.getElementById("iframe").contentWindow.MMAPI.switching("back");
        document
          .getElementById("iframe")
          .contentWindow.MMAPI.gasocausis("back");
      } else if (this.type == "3jw3") {
        document
          .getElementById("iframe")
          .contentWindow.MMAPI.equipmentover("3jw3");
      } else if (this.type == "3jw4") {
        document
          .getElementById("iframe")
          .contentWindow.MMAPI.equipmentover("3jw4");
      } else if (this.type == "3jw5") {
        document
          .getElementById("iframe")
          .contentWindow.MMAPI.equipmentover("3jw5");
      } else if (this.type == "5jw1") {
        document
          .getElementById("iframe")
          .contentWindow.MMAPI.equipmentover("5jw1");
      } else if (this.type == "5jw3") {
        document
          .getElementById("iframe")
          .contentWindow.MMAPI.equipmentover("5jw3");
      } else if (this.type == "Lxlou") {
        document
          .getElementById("iframe")
          .contentWindow.MMAPI.equipmentover("Lxlou");
      }
    },
    showReset(num) {
      if (num == 0) {
        this.show1 = true;
        this.show2 = true;
        this.show3 = true;
        this.show4 = true;
        this.show5 = true;
        this.show6 = true;
      } else if (num == 1) {
        this.show0 = true;
        this.show2 = true;
        this.show3 = true;
        this.show4 = true;
        this.show5 = true;
        this.show6 = true;
        this.$store.state.show = true;
      } else if (num == 2) {
        this.show0 = true;
        this.show1 = true;

        this.show3 = true;
        this.show4 = true;
        this.show5 = true;
        this.show6 = true;
        this.$store.state.show = true;
      } else if (num == 3) {
        this.show0 = true;
        this.show1 = true;
        this.show2 = true;

        this.show4 = true;
        this.show5 = true;
        this.show6 = true;
        this.$store.state.show = true;
      } else if (num == 4) {
        this.show0 = true;
        this.show1 = true;
        this.show2 = true;
        this.show3 = true;

        this.show5 = true;
        this.show6 = true;
        this.$store.state.show = true;
      } else if (num == 5) {
        this.show0 = true;
        this.show1 = true;
        this.show2 = true;
        this.show3 = true;
        this.show4 = true;

        this.show6 = true;
        this.$store.state.show = true;
      } else if (num == 6) {
        this.show0 = true;
        this.show1 = true;
        this.show2 = true;
        this.show3 = true;
        this.show4 = true;
        this.show5 = true;

        this.$store.state.show = true;
      }
    },
    initialization() {
      this.show0 = true;
      this.show1 = true;
      this.show2 = true;
      this.show3 = true;
      this.show4 = true;
      this.show5 = true;
      this.show6 = true;
      this.num1 = -1;
      let list2 = [
        {
          bg: require("./../assets/img/bottom-list2.png"),
          title: "地图引导",
        },
        {
          bg: require("./../assets/img/bottom-list5.png"),
          title: "消防设备",
        },
        {
          bg: require("./../assets/img/bottom-list7.png"),
          title: "摄像头",
        },
        {
          bg: require("./../assets/img/bottom-list3.png"),
          title: "供气站",
        },
        {
          bg: require("./../assets/img/bottom-list1.png"),
          title: "志愿者服务站",
        },
        {
          bg: require("./../assets/img/bottom-list4.png"),
          title: "医疗站",
        },

        {
          bg: require("./../assets/img/bottom-list6.png"),
          title: "供电系统",
        },
      ];
      this.list1 = list2;
      this.$store.state.map = false;
      this.$store.state.show = true;
      this.$store.state.idbottom = true;
    },
    activeN(num) {
      let that = this;
      return {
        0: function () {
          document.getElementById("iframe").contentWindow.MMAPI.atlas(0);
          if (that.show0) {
            that.$store.state.show = false;
            that.$store.state.map = true;
            that.list1[num].bg = require("./../assets/img/active-list2.png");
            that.show0 = false;
            that.$store.state.idbottom = false;
          } else {
            that.$store.state.show = true;
            that.$store.state.map = false;
            that.list1[num].bg = require("./../assets/img/bottom-list2.png");
            that.show0 = true;
            that.num1 = -1;
            that.goback();
          }
        },
        1: function () {
          that.$store.state.map = false;
          that.$store.state.idbottom = false;
          if (that.show1) {
          
            that.list1[num].bg = require("./../assets/img/active-list5.png");
            that.show1 = false;
            if (that.type == "initialize") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.equipment("initialize-fire");
            } else if (that.type == "3jw3") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.equipment("3jw3xss");
            } else if (that.type == "3jw5") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.equipment("3jw5xss");
            } else if (that.type == "5jw1") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.equipment("5jw1xss");
            } else if (that.type == "3jw4") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.equipment("3jw4xss");
            }
          } else {
            that.list1[num].bg = require("./../assets/img/bottom-list5.png");
            that.show1 = true;
            that.num1 = -1;
            that.goback();
          }
        },
        2: function () {
          that.$store.state.map = false;
          that.$store.state.idbottom = false;
          if (that.show2) {
            that.list1[num].bg = require("./../assets/img/active-list7.png");
            that.show2 = false;

            if (that.type == "initialize") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.equipment("initialize-camera");
            } else if (that.type == "3jw3") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.equipment("3jw3");
            } else if (that.type == "3jw4") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.equipment("3jw4");
            } else if (that.type == "3jw5") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.equipment("3jw5");
            } else if (that.type == "3jw3xss") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.equipment("3jw3xss");
            } else if (that.type == "3jw5xss") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.equipment("3jw5xss");
            } else if (that.type == "5jw1xss") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.equipment("5jw1xss");
            } else if (that.type == "5jw1") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.equipment("5jw1");
            } else if (that.type == "Lxlou") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.equipment("Lxlou");
            } else if (that.type == "5jw3") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.equipment("5jw3");
            }
          } else {
            that.list1[num].bg = require("./../assets/img/bottom-list7.png");
            that.show2 = true;
            that.num1 = -1;
            that.goback();
          }
        },
        3: function () {
          that.$store.state.map = false;
          that.$store.state.idbottom = false;
          if (that.show3) {
            that.list1[num].bg = require("./../assets/img/active-list3.png");
            that.show3 = false;
            document
              .getElementById("iframe")
              .contentWindow.MMAPI.gasocausis("clzx");
          } else {
            that.list1[num].bg = require("./../assets/img/bottom-list3.png");
            that.show3 = true;
            that.num1 = -1;
            document
              .getElementById("iframe")
              .contentWindow.MMAPI.gasocausis("back");
          }
        },
        4: function () {
          that.$store.state.map = false;
          that.$store.state.idbottom = false;
          if (that.show4) {
            that.list1[num].bg = require("./../assets/img/active-list1.png");
            that.show4 = false;
            document.getElementById("iframe").contentWindow.MMAPI.volunteer();
          } else {
            that.list1[num].bg = require("./../assets/img/bottom-list1.png");
            that.show4 = true;
            that.num1 = -1;
            document
              .getElementById("iframe")
              .contentWindow.MMAPI.gasocausis("back");
          }
        },
        5: function () {
          that.$store.state.map = false;
          that.$store.state.idbottom = false;
          if (that.show5) {
            that.list1[num].bg = require("./../assets/img/active-list4.png");
            that.show5 = false;
            document.getElementById("iframe").contentWindow.MMAPI.medical();
          } else {
            that.list1[num].bg = require("./../assets/img/bottom-list4.png");
            that.show5 = true;
            that.num1 = -1;
            document
              .getElementById("iframe")
              .contentWindow.MMAPI.gasocausis("back");
          }
        },
        6: function () {
          that.$store.state.map = false;
          that.$store.state.idbottom = false;
          if (that.show6) {
            that.list1[num].bg = require("./../assets/img/active-list6.png");
            that.show6 = false;
            if (that.type == "initialize") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.switching("initialize-ching");
            } else if (that.type == "3jw3") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.switching("3jw3");
            } else if (that.type == "3jw4") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.switching("3jw4");
            } else if (that.type == "3jw5") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.switching("3jw5");
            } else if (that.type == "5jw1") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.switching("5jw1");
            } else if (that.type == "5jw3") {
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.switching("5jw3");
            }
          } else {
            that.list1[num].bg = require("./../assets/img/bottom-list6.png");
            // document.getElementById("iframe").contentWindow.MMAPI.switching("back");
            that.show6 = true;
            that.num1 = -1;
            that.goback();
          }
        },
      };
    },
    back() {
      document.getElementById("iframe").contentWindow.MMAPI.apes();
      document.getElementById("iframe").contentWindow.MMAPI.Buildingreturn();
    },
    show() {
      var os = (function () {
        var ua = navigator.userAgent,
          isWindowsPhone = /(?:Windows Phone)/.test(ua),
          isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
          isAndroid = /(?:Android)/.test(ua),
          isFireFox = /(?:Firefox)/.test(ua),
          // var isChrome = /(?:Chrome|CriOS)/.test(ua),
          isTablet =
            /(?:iPad|PlayBook)/.test(ua) ||
            (isAndroid && !/(?:Mobile)/.test(ua)) ||
            (isFireFox && /(?:Tablet)/.test(ua)),
          isPhone = /(?:iPhone)/.test(ua) && !isTablet,
          isPc = !isPhone && !isAndroid && !isSymbian;
        return {
          isTablet: isTablet,
          isPhone: isPhone,
          isAndroid: isAndroid,
          isPc: isPc,
        };
      })();
      if (os.isAndroid || os.isPhone) {
        // 手机
      } else if (os.isTablet) {
        // 平板
        this.showNum = 1;
      } else if (os.isPc) {
        // pc
        this.showNum = -1;
      }
    },
    showfalse() {
      this.$store.state.idbottom = false;
    },
  },
};
</script>
<style scoped>
.nav-bottom {
  height: 5vh;
  width: 100vw;
  position: fixed;
  bottom: 0;
  background: url("./../assets/img/nav-bottom.png") no-repeat;
  background-size: 100% 100%;
}
.bottom {
  width: 12.4rem;
  height: 5vh;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background: url("./../assets/img/bottom.png") no-repeat;
  background-size: 100% 100%;
  user-select: none;
}
.bottom ul {
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  top: -0.4875rem;
  display: flex;
  padding-left: 15%;
  font-family: "SourceHanSansCN";
  color: #fff;
}
.bottom ul li {
  width: 1.125rem;
  height: 0.875rem;
  display: flex;
  justify-content: center;
  position: relative;
  flex-wrap: wrap;
  margin-right: 0.11rem;
}
.bottom ul li:nth-child(1) {
  width: 1.3625rem;
  margin-right: 0.0375rem;
}

.bottom ul li .list-bg {
  width: 0.75rem;
  height: 0.75rem;
  overflow: hidden;
}
.bottom ul li .list-bg img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.bottom ul li:nth-child(1) .list-bg {
  background-size: 100% 100%;
}
.bottom ul li:nth-child(2) .list-bg {
  /* background: url("./../assets/img/bottom-list2.png") no-repeat; */
  background-size: 100% 100%;
}
.bottom ul li:nth-child(3) .list-bg {
  background-size: 100% 100%;
}
.bottom ul li:nth-child(4) .list-bg {
  background-size: 100% 100%;
}
.bottom ul li:nth-child(5) .list-bg {
  background-size: 100% 100%;
}
.bottom ul li:nth-child(6) .list-bg {
  background-size: 100% 100%;
}
.bottom ul li:nth-child(7) .list-bg {
  background-size: 100% 100%;
}
.bottom ul li span {
  display: block;
  position: absolute;
  bottom: -0.04rem;
  font-size: 0.15rem;
  white-space: nowrap;
}
.drop {
  position: absolute;
  width: 0.1625rem;
  height: 0.15rem;
  background: url("./../assets/img/drop.png") no-repeat;
  background-size: 100% 100%;
  left: 51%;
  transform: translateX(-50%);
  bottom: 0.0625rem;
}
.bottom-line {
  position: absolute;
  width: 100%;
  bottom: -0.05rem;
  height: 0.0125rem;
  background: url("./../assets/img/bottom-line.png") no-repeat;
  background-size: 100% 100%;
}
.active {
  color: #ffeab2;
}
.back {
  position: absolute;
  right: -8%;
  top: -35%;
  /* background: url("./../assets/img/返回.png") no-repeat; */
  background-size: 100% 100%;
  width: 50px;
  height: 45px;
  outline: none;
  overflow: hidden;
  outline: none;
  border: 0px;
  background: -webkit-linear-gradient(bottom, #7db2ff, #ffffff);
  padding: 0;
  border-radius: 16px;
}
</style>




